import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  paper: {
    boxShadow: 'none',
    border: '1px solid #C6C6C6',
    borderTop: '1px solid #C6C6C6',
    borderRight: '1px solid #C6C6C6',
    borderBottom: '1px solid #C6C6C6',
    borderLeft: '1px solid #C6C6C6',
    marginBottom: '10px',
  },
  tableWrapper: {
    width: "100%",
    // PD expanded-row consistency with PO Dashboard: no internal scroll on the
    // table. Previously this wrapper set overflowX/overflowY:'auto' and a
    // viewport-relative maxHeight, which produced a nested vertical scrollbar
    // inside the tab area on top of the page's own scroll. Removed both. The
    // page (parent scroll region) now owns the single vertical and horizontal
    // scrollbars — the table flows to its natural size and never scrolls
    // separately.
    overflowX: "visible",
    overflowY: "visible",
    maxHeight: 'none',
  },
  table: {
    minWidth: 650,
  },
  // Sticky is declared here (not left to MUI's `stickyHeader` defaults) so the
  // opaque #F9F9FC background wins over MUI's theme background and rows don't
  // show through while scrolling.
  headerCell: {
    backgroundColor: '#F9F9FC',
    fontWeight: "bold",
    padding: '10px',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    borderBottom: '1px solid #C6C6C6',
  },
  tableCell: {
    padding: '10px',
    borderBottom: '1px solid #C6C6C6',
  },
  uomCell: {
    padding: '10px',
    whiteSpace: 'nowrap',
    borderBottom: '1px solid #C6C6C6',
  },
  tableRow: {
    '&:last-child td': {
      borderBottom: 'none',
    },
  },
  pdfLink: {
    color: '#1976d2',
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

